export default "__VITE_ASSET__yXgB1WgR__"